import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getDomainListSlice = createApi(`GetDomainListSlice`,"GET");

const GetDomainListSlice = createSlice({
  name: 'GetDomainListSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDomainListSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDomainListSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDomainListSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetDomainListSlice.reducer;